import { render, staticRenderFns } from "./createDemand.vue?vue&type=template&id=fd609974&scoped=true&"
import script from "./createDemand.vue?vue&type=script&lang=js&"
export * from "./createDemand.vue?vue&type=script&lang=js&"
import style0 from "./createDemand.vue?vue&type=style&index=0&id=fd609974&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd609974",
  null
  
)

export default component.exports